import { extractImageFrames, clampTo } from '../../tools';
import type { WavespeedModelConfig } from '../types';

export const ltxConfigs: Record<string, WavespeedModelConfig> = {
    'ltx-2.5': {
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/ltx-2.5/text-to-video
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/ltx-2.5/image-to-video
        apiPath: (params) => {
            const { frameMode } = params;
            if (frameMode === 'first' || frameMode === 'first_last') {
                return '/wavespeed-ai/ltx-2.5/image-to-video';
            } else {
                return '/wavespeed-ai/ltx-2.5/text-to-video';
            }
        },
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, aspectRatio, duration, quality, modelUi, providerOptions } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage, lastImage] = extractImageFrames(imagePrompt);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    prompt: prompt,
                    duration: clampTo(duration || 5, [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20] as const, 5),
                    resolution: clampTo(quality || '720p', ['720p', '1080p', '2k', '4k'] as const, '720p'),
                    seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                    // 首帧 URL
                    image: firstImage,
                };
            // 首尾帧模式
            } else if (frameMode === 'first_last') {
                return {
                    prompt: prompt,
                    duration: clampTo(duration || 5, [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20] as const, 5),
                    resolution: clampTo(quality || '720p', ['720p', '1080p', '2k', '4k'] as const, '720p'),
                    seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                    // 首帧 URL
                    image: firstImage,
                    // 尾帧 URL
                    last_image: lastImage,
                };
            // 文生视频模式
            } else {
                return {
                    prompt: prompt,
                    aspect_ratio: clampTo(aspectRatio || '16:9', ['16:9', '9:16'] as const, '16:9'),
                    duration: clampTo(duration || 5, [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20] as const, 5),
                    resolution: clampTo(quality || '720p', ['720p', '1080p', '2k', '4k'] as const, '720p'),
                    seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                };
            }
        },
    },
};
